module.exports = __webpack_public_path__ + "static/media/facebook-icon-hover-2.dd313759.svg";